import range from './range.js';

const monthListOptions = () => range(1, 12)
	.map(key => (String(key)).padStart(2, '0'));
export default monthListOptions;
